import { dialogTypes } from '@/dialogs'
import { reportDesignerDialogs } from '@/components/reportDesigner/dialogs'

export default {
  ...reportDesignerDialogs,
  [dialogTypes.alert]: require('@/dialogs/alert').default,
  [dialogTypes.confirm]: require('@/dialogs/confirm').default,
  [dialogTypes.prompt]: require('@/dialogs/prompt').default,
  [dialogTypes.impersonation]: require('@/dialogs/impersonation').default,
  [dialogTypes.cellComment]: require('@/dialogs/cellComment').default,
  [dialogTypes.newTicket]: require('@/dialogs/newTicket').default,
  [dialogTypes.taskResultEditor]: require('@/dialogs/taskResultEditor').default,
  [dialogTypes.address]: require('@/dialogs/address').default,
  [dialogTypes.codeListEditor]: require('@/dialogs/codeListEditor').default,
  [dialogTypes.institutionGroup]: require('@/dialogs/institutionGroup/index').default,
  [dialogTypes.license]: require('@/dialogs/license').default,
  [dialogTypes.contactInformation]: require('@/dialogs/contactInformation').default,
  [dialogTypes.relatedInstitution]: require('@/dialogs/relatedInstitution').default,
  [dialogTypes.relatedPerson]: require('@/dialogs/relatedPerson').default,
  [dialogTypes.branch]: require('@/dialogs/branch').default,
  [dialogTypes.realEstate]: require('@/dialogs/realEstate').default,
  [dialogTypes.personalId]: require('@/dialogs/personalId').default,
  [dialogTypes.ban]: require('@/dialogs/ban').default,
  [dialogTypes.individualInCharge]: require('@/dialogs/individualInCharge').default,
  [dialogTypes.organizationalUnit]: require('@/dialogs/organizationalUnit').default,
  [dialogTypes.jobTitle]: require('@/dialogs/jobTitle').default,
  [dialogTypes.submissionDate]: require('@/dialogs/submissionDate').default,
  [dialogTypes.newReportingCycle]: require('@/dialogs/newReportingCycle').default,
  [dialogTypes.editDocumentationItem]: require('@/dialogs/editDocumentationItem').default,
  [dialogTypes.addDashboardWidget]: require('@/dialogs/addDashboardWidget').default,
  [dialogTypes.addNewAnnouncement]: require('@/dialogs/addNewAnnouncement').default,
  [dialogTypes.job]: require('@/dialogs/job').default,
  [dialogTypes.newReportingHolidays]: require('@/dialogs/newReportingHolidays').default,
  [dialogTypes.institution]: require('@/dialogs/institution').default,
  [dialogTypes.institutionPermission]: require('@/dialogs/institutionPermission/institutionPermission').default,
  [dialogTypes.individualPermission]: require('@/dialogs/institutionPermission/internalPermission').default,
  [dialogTypes.addUserRole]: require('@/dialogs/addUserRole').default,
  [dialogTypes.editInChargeOfInstitutions]: require('@/dialogs/editInChargeOfInstitution').default,
  [dialogTypes.reportTemplateSelector]: require('@/dialogs/reportTemplateSelector').default,
  [dialogTypes.reportTemplateImport]: require('@/dialogs/reportTemplateImport').default,
  [dialogTypes.branchManagers]: require('@/dialogs/branchManagers').default,
  [dialogTypes.addNewReportingGroup]: require('@/dialogs/addNewReportingGroup').default,
  [dialogTypes.editPlainText]: require('@/dialogs/editPlainText').default,
  [dialogTypes.exportPdf]: require('@/dialogs/exportPdf').default,
  [dialogTypes.editCycleParameters]: require('@/dialogs/editCycleParameters/index').default,
  [dialogTypes.inputPassphrase]: require('@/dialogs/inputPassphrase').default,
  [dialogTypes.inputPatTokenName]: require('@/dialogs/inputPatTokenName').default,
  [dialogTypes.generatedPatToken]: require('@/dialogs/generatedPatToken').default,
  [dialogTypes.capitalOperation]: require('@/dialogs/capitalOperation').default,
  [dialogTypes.course]: require('@/dialogs/course').default,
  [dialogTypes.education]: require('@/dialogs/education').default,
  [dialogTypes.experience]: require('@/dialogs/experience').default,
  [dialogTypes.helpPreview]: require('@/dialogs/helpPreview').default,
  [dialogTypes.addIndividualDuplicity]: require('@/dialogs/addIndividualDuplicate').default,
  [dialogTypes.editPhoneNumber]: require('@/dialogs/editPhoneNumber').default,
  [dialogTypes.addDataCrossingWeight]: require('@/dialogs/addDataCrossingWeight').default,
  [dialogTypes.addDataCrossingAllowedCombination]: require('@/dialogs/addDataCrossingAllowedCombination').default,
  [dialogTypes.problematicCombination]: require('@/dialogs/problematicCombination').default,
  [dialogTypes.twoFactorAuthentication]: require('@/dialogs/twoFactorAuthentication/index').default,
  [dialogTypes.twoFactorSetup]: require('@/dialogs/twoFactorSetup/index').default,
  [dialogTypes.addOutputReportGroup]: require('@/dialogs/addNewOutputReportGroupDefinition').default,
  [dialogTypes.bankAccountNumber]: require('@/dialogs/bankAccountNumber').default,
  [dialogTypes.editLegacyCode]: require('@/dialogs/editLegacyCode').default,
  [dialogTypes.blacklistDetail]: require('@/dialogs/blacklistDetail').default,
  [dialogTypes.editCheckingRule]: require('@/dialogs/editCheckingRule').default,
  [dialogTypes.userSelector]: require('@/dialogs/userSelector').default,
  [dialogTypes.selectReportTemplateCategory]: require('@/dialogs/selectReportTemplateCategory').default,
  [dialogTypes.editReportTemplateCategory]: require('@/dialogs/editReportTemplateCategory').default,
  [dialogTypes.reportGroupPermission]: require('@/dialogs/reportGroupPermission').default,
  [dialogTypes.bgJobMessages]: require('@/dialogs/bgJobMessages').default,
  [dialogTypes.validationErrors]: require('@/dialogs/validationErrors').default,
  [dialogTypes.outputReportGroupDefinitionPermissions]: require('@/dialogs/outputReportGroupDefinitionPermissions').default,
  [dialogTypes.addWorkflowVersion]: require('@/dialogs/addWorkflowVersion').default,
  [dialogTypes.editConstantCategory]: require('@/dialogs/editConstantCategory').default,
  [dialogTypes.editConstant]: require('@/dialogs/editConstant').default,
  [dialogTypes.editDimension]: require('@/dialogs/editDimension').default,
  [dialogTypes.editDimensionItem]: require('@/dialogs/editDimensionItem').default,
  [dialogTypes.addColumnBinding]: require('@/dialogs/addColumnBinding').default,
  [dialogTypes.composeNewMessage]: require('@/dialogs/composeNewMessage').default,
  [dialogTypes.viewMessage]: require('@/dialogs/viewMessage').default,
  [dialogTypes.auditLog]: require('@/dialogs/auditInfo').default,
  [dialogTypes.setValidRange]: require('@/dialogs/setValidRange').default,
  [dialogTypes.outputReportInstitutions]: require('@/dialogs/outputReportInstitutions').default,
  [dialogTypes.outputReportSources]: require('@/dialogs/outputReportSources').default
}



// WEBPACK FOOTER //
// ./src/internal-app/dialogs.js